import styled from 'styled-components'
import { widthResize, widthFull, heightFooter, muted, borderSoft, bgApp } from '../Resources/Theme'

export default styled.footer`
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  margin-left: ${props => props.resize ? widthResize : widthFull};
  transition: .35s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${heightFooter};
  color: ${muted};
  font-size: 0.7rem;
  background: ${bgApp};
  border-top: 1px solid ${borderSoft};

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }
`
